export default __webpack_public_path__ + "static/1229-6d50c9a758a8537f48398e44c15d5fc2.gif";